'use client';

import type { HTMLAttributes } from 'react';
import { PassportLogin } from '../PassportLogin/PassportLogin';

export function HeaderButtonSignIn(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <div id="header-sign-in-btn" data-testid="header-sign-in-btn" data-cy="header-sign-in-btn" {...props}>
      <PassportLogin compact />
    </div>
  );
}
